// tslint:disable:max-line-length

import React from 'react';

export const EditorUnorderedList = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,1v2h2V1H0z M4,1v2h12V1H4z M0,7v2h2V7H0z M4,7v2h12V7H4z M0,13v2h2v-2H0z M4,13v2h12v-2H4z" />
    </svg>
  );
};
